/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacCapricorn = [
  ["path", { d: "M11 21a3 3 0 0 0 3-3V6.5a1 1 0 0 0-7 0" }],
  ["path", { d: "M7 19V6a3 3 0 0 0-3-3h0" }],
  ["circle", { cx: "17", cy: "17", r: "3" }]
];

export { ZodiacCapricorn as default };
//# sourceMappingURL=zodiac-capricorn.js.map
